export default __webpack_public_path__ + "static/media/18.db0a5ead.jpg";